import { render, staticRenderFns } from "./NeoparentShadowDictionary.vue?vue&type=template&id=0cf5d6cb&scoped=true"
import script from "./NeoparentShadowDictionary.vue?vue&type=script&lang=js"
export * from "./NeoparentShadowDictionary.vue?vue&type=script&lang=js"
import style0 from "./NeoparentShadowDictionary.vue?vue&type=style&index=0&id=0cf5d6cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf5d6cb",
  null
  
)

export default component.exports